<template>
  <div>
    <WsDialog
      v-model="dialog"
      ref="WsDialog"
      :title="_title"
      :isCloseScrollTop="isCloseScrollTop"
    >
      <template v-slot:content>
        <v-skeleton-loader v-if="isLoading" type="paragraph"></v-skeleton-loader>
        <ValidationObserver v-else ref="form">
          <slot name="content" :modelData="modelData" :updateData="updateData" :dialog="dialog">
            <v-form
              ref="createForm"
              @submit.prevent
            >
              <WsStateLocales
                v-if="_localeField&&dialog"
                :fields="_localeField.fields"
                :value="updateData[_localeFieldKey]"
                @input="$_onInput(_localeFieldKey,$event)"
              ></WsStateLocales>
              <v-row>
                <v-col
                  v-for="(field, fieldKey) in _generalFields"
                  cols="12"
                  :sm="field.sm ? field.sm : 12"
                  :key="fieldKey"
                >
                  <WsState
                    v-if="dialog"
                    :type="field.type"
                    :label="field.label"
                    :fields="field.fields"
                    :rules="field.rules"
                    :items="field.items"
                    :disabled="field.disabled"
                    :modelName="field.modelName"
                    :textKey="field.textKey"
                    :placeholder="field.placeholder"
                    :uploadUrl="field.uploadUrl"
                    :note="field.note"
                    :maxWidth="field.maxWidth"
                    :autofocus="field.autofocus"
                    :parent="field.parentKey"
                    :parentState="$_getParentState(fieldKey)"
                    :parentStateName="field.parentStateName"
                    :requiredField="field.requiredField"
                    :displayLabel="field.displayLabel"
                    :excludeSelf="field.excludeSelf"
                    :maxlength="field.maxlength"
                    :value="updateData[fieldKey]"
                    :modelId="id"
                    :originValue="$_getOriginValue(modelData,fieldKey)"
                    :originData="updateData"
                    :errorMessage="$_getErrorMessage(fieldKey)"
                    :compareStr="field.compareStr"
                    :conditions="$_getConditions(fieldKey)"
                    :layersSetting="$_getFieldAttr(fieldKey, 'layersSetting')"
                    :requiredFieldState="$_getParentState(fieldKey)"
                    :getUrl="$_getFieldAttr(fieldKey, 'getUrl')"
                    :multiple="$_getFieldAttr(fieldKey, 'multiple')"
                    :activeText="$_getFieldAttr(fieldKey,'activeText')"
                    :inactiveText="$_getFieldAttr(fieldKey,'inactiveText')"
                    @input="$_onInput(fieldKey,$event)"
                  />
                </v-col>
              </v-row>
            </v-form>
          </slot>
        </ValidationObserver>
      </template>
      <template v-slot:leftActions>
        <WsBtn
          v-for="(item,index) in customBtns.left"
          :key="`left${index}`"
          :color="item.color"
          item.type
          :outlined="item.outlined"
          :to="item.to"
          :loading="isLoading || submitLoading"
          @click="$_onCustomAction(item)"
        >
          <v-icon v-if="item.icon" left>
            {{item.icon}}
          </v-icon> 
          {{item.title}}
        </WsBtn>
      </template>
      <template v-slot:rightActions>
        <WsBtn
          @click="$_onCancel()"
          minWidth="100px"
          color="textSecondary"
          outlined
          :loading="isLoading || submitLoading"
        >取消</WsBtn>
        <WsBtn
          @click="$_onSubmit()"
          minWidth="100px"
          :loading="isLoading || submitLoading"
          color="primary"
        >送出</WsBtn>
      </template>
    </WsDialog>
  </div>
</template>

<script>
export default {
  data: () => ({
    modelData: null,
    updateData: {},
    submitLoading: false,
    dialog: false,
    id: null,
  }),
  methods: {
    $_getErrorMessage(fieldKey) {
      if (this.errorMessages) {
        if (this.errorMessages[fieldKey]) {
          return this.errorMessages[fieldKey];
        } else {
          return null;
        }
      } else {
        return null;
      }
    },
    $_getParentState(fieldKey) {
      const field = this.$_CMS_getFieldByFieldKey(fieldKey, this._generalFields);
      if (field.parentKey) {
        return this.updateData[field.parentKey];
      } else if (field.requiredField) {
        return this.updateData[field.requiredField];
      } else {
        return null;
      }
    },
    $_getOriginValue(modelData, fieldKey) {
      if (!modelData) {
        return null;
      } else {
        return modelData[fieldKey];
      }
    },
    $_onInput(fieldKey, $event) {
      this.updateData = {
        ...this.updateData,
        [fieldKey]: $event,
      };
    },
    stopLoading() {
      this.submitLoading = false;
    },
    startLoading() {
      this.submitLoading = true;
    },
    async $_onSubmit() {
      const isValidate = await this.$refs.form.validate();
      if (!isValidate) {
        return;
      }
      this.$_checkNotNull();
      this.$emit("update-submit", {
        ...this.updateData,
        id: this.id,
      });
    },
    $_checkNotNull() {
      const addFieldsKey = Object.keys(this._generalFields);
      addFieldsKey.forEach((fieldKey) => {
        if (
          this._generalFields[fieldKey].updateNotNull &&
          !this.updateData[fieldKey]
        ) {
          delete this.updateData[fieldKey];
        }
      });
    },
    $_onCancel() {
      this.close();
    },
    close() {
      this.dialog = false;
      this.reset();
    },
    reset() {
      if (this.$refs.form) this.$refs.form.reset();
      this.submitLoading = false;
    },
    open(item) {
      this.modelData = item;
      this.id = item ? item.id : null;
      this.$_CMS_updateDataSetFromFields(
        this,
        this.updateData,
        this.fields,
        item
      );
      this.dialog = true;
    },
    $_onCustomAction(item) {
      if (item.emit) {
        this.$emit(item.emit, this.modelData);
      }
    },
    $_getConditions(fieldKey) {
      const _conditions = [];
      const conditionKeys = this.$_getFieldAttr(fieldKey, "conditionKeys");
      if (!conditionKeys) {
        return [];
      }
      conditionKeys.forEach((conditionKey) => {
        let _value = "";
        if (this.updateData[conditionKey.fieldName]) {
          _value = this.updateData[conditionKey.fieldName];
        } else if (this.modelData && this.modelData[conditionKey.fieldName]) {
          _value = this.modelData[conditionKey.fieldName].id;
        } else {
          _value = null
        }
        _conditions.push({
          key: conditionKey.conditionName,
          value: _value,
          type: conditionKey.type,
        });
      });
      return _conditions;
    },
    $_getFieldAttr(fieldKey, keyName) {
      const field = this.$_CMS_getFieldByFieldKey(fieldKey, this._generalFields);
      return field[keyName];
    },
  },
  computed: {
    _generalFields() {
      const _generalFields = {};
      for (let fieldKey in this.fields) {
        const field = this.fields[fieldKey];
        if (field.type == "locales" || field.hide) {
          continue;
        }
        _generalFields[fieldKey] = field;
      }
      return _generalFields;
    },
    _localeField() {
      let _localeField = null;
      for (let fieldKey in this.fields) {
        const field = this.fields[fieldKey];
        if (field.type == "locales") {
          _localeField = field;
        }
      }
      return _localeField;
    },
    _localeFieldKey() {
      let _localeFieldKey = null;
      for (let fieldKey in this.fields) {
        const field = this.fields[fieldKey];
        if (field.type == "locales") {
          _localeFieldKey = fieldKey;
        }
      }
      return _localeFieldKey;
    },
    _title() {
      if (this.customTitle) {
        return this.label;
      } else {
        return `編輯${this.label}`;
      }
    },
  },
  props: {
    errorMessages: {
      type: Object,
      default: null,
    },
    modelName: String,
    label: {
      type: String,
      default: null,
    },
    customTitle: {
      type: Boolean,
      default: false,
    },
    fields: Object,
    customBtns: {
      type: Object,
      default: function (){
        return {}
      }
    },
    isCloseScrollTop: {
      type: Boolean,
      default: false,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    dialog: {
      handler() {
        if (!this.dialog) {
          this.reset();
        }
      },
    },
  },
};
</script>